import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export class Progress {

  show = false;
  percent = 0;
  step = 1;

  constructor(showProgress: boolean, progressPercent: number, stepProgress: number) {
    this.percent = progressPercent;
    this.show = showProgress;
    this.step = stepProgress;
  }

}

@Injectable()
export class ProgressTrackerService {

  public ShowProgressTrackerSource = new Subject<Progress>();
  toggleProgressTracker$: any = this.ShowProgressTrackerSource.asObservable();

  constructor() { }

}
